import { useMemo } from 'react';
import { useGeneralRoutes, useOtherSettings } from '@namespace/cms';
import { IHUB_NOTIFICATION_TYPES } from '../../constants';

export const useGetGameLaunchError = (errorCode) => {
  const routes = useGeneralRoutes();
  const { wallets } = routes;
  const { responsibleGamblingErrorCodeLinkToMap = {} } = useOtherSettings();
  const errorsMapNew = useMemo(() => {
    const rgExclusionLimit = {
      errorTextTranslationKey: 'web.responsible.gambling.exclusionlimit.info'
    };
    const rgBetReachedLimit = {
      errorTextTranslationKey: 'web.responsible.gambling.limits.bet.reached',
      linkTo: responsibleGamblingErrorCodeLinkToMap.ihub_1101,
      linkTextTranslationKey: 'web.responsible.gambling.limits.bet.change'
    };
    const rgLossReachedLimit = {
      errorTextTranslationKey: 'web.responsible.gambling.limits.loss.reached',
      linkTo: responsibleGamblingErrorCodeLinkToMap.ihub_1102,
      linkTextTranslationKey: 'web.responsible.gambling.limits.loss.change'
    };
    const rgActivityLimit = {
      errorTextTranslationKey:
        'web.casino.unavailablegame.durationreached.message'
    };
    const rgNonSetLimits = {
      errorTextTranslationKey:
        'web.casino.unavailablegame.nonsetlimits.message',
      linkTo: responsibleGamblingErrorCodeLinkToMap.ihub_1104,
      linkTextTranslationKey: 'web.casino.unavailablegame.nonsetlimits.button'
    };

    return {
      ihub_1001: {
        errorTextTranslationKey: 'web.game.error.ihub_1001'
      },
      ihub_1003: {
        errorTextTranslationKey: 'casino.gameContainer.error.noActiveWallet',
        linkTo: wallets,
        linkTextTranslationKey: 'header.wallets'
      },
      ihub_1010: {
        errorTextTranslationKey: 'web.game.error.ihub_1010'
      },
      ihub_1011: {
        errorTextTranslationKey: 'web.game.error.ihub_1011'
      },
      ihub_1012: {
        errorTextTranslationKey: 'web.game.error.ihub_1012'
      },
      9: {
        errorTextTranslationKey: 'casino.gameContainer.error.cantStartSession'
      },
      noErrorCode: {
        errorTextTranslationKey: 'casino.gameContainer.error.noErrorCode'
      },
      ihub_1100: rgExclusionLimit,
      ihub_1101: rgBetReachedLimit,
      ihub_1102: rgLossReachedLimit,
      ihub_1103: rgActivityLimit,
      ihub_1104: rgNonSetLimits,
      [IHUB_NOTIFICATION_TYPES.blocked_by_exclusion]: rgExclusionLimit,
      [IHUB_NOTIFICATION_TYPES.blocked_by_max_loss_limit]: rgLossReachedLimit,
      [IHUB_NOTIFICATION_TYPES.blocked_by_game_activity_limit]: rgActivityLimit,
      [IHUB_NOTIFICATION_TYPES.blocked_by_missing_required_limits]:
        rgNonSetLimits,
      [IHUB_NOTIFICATION_TYPES.blocked_by_max_bet_limit]: rgBetReachedLimit
    };
  }, [wallets, responsibleGamblingErrorCodeLinkToMap]);

  return errorsMapNew[errorCode] || errorsMapNew.noErrorCode;
};
